// extracted by mini-css-extract-plugin
export default {"label":"Email_label__Bbapl","formBox":"Email_formBox__biCYe","btn":"Email_btn__-jL5N","input":"Email_input__dGCew","textArea":"Email_textArea__wpOqL"};